import React, { useState, useEffect } from 'react';
import axios from 'axios';
import Select from 'react-select';
import { Card, CardBody, FormGroup, Label, Input, Button } from 'reactstrap';
import { Breadcrumbs, H6 } from '../../AbstractElements';
import HeaderCard from '../../myComponents/HeaderCard';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useParams } from 'react-router';

const WorkoutProgram = () => {
    const [loader, setLoader] = useState(false);
    const {id} = useParams();

    const [options, setOptions] = useState([]);
    const [selectedOptions, setSelectedOptions] = useState([]);
    const [searchTerm, setSearchTerm] = useState('');
    const [weekDuration, setWeekDuration] = useState('');
    const token = useSelector(state => state.auth.userToken);

    useEffect(() => {
        const fetchDailyData = async () => {
            try {
                const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/add/getDaily`);

                const dailyOptions = response.data.dailyWorkOut.map(item => ({
                    value: item._id,
                    label: item.workOutName,
                }));
                setOptions(dailyOptions);
            } catch (error) {
                console.error('Error fetching daily data:', error);
            }
        };

        fetchDailyData();
    }, []);

    useEffect(() => {
        const fetchWorkoutProgram = async () => {
            if (id) {
                setLoader(true);
                const config = {
                  headers: {
                      Authorization: `Bearer ${token}`,
                  },
              };
  
                try {
                    const response = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/home/showWorkOutProgram/${id}`,config);
                    const workoutProgram = response.data.workoutProgram;

                    const selectedOptions = workoutProgram.dailyIds.map(dailyId => {
                        const option = options.find(option => option.value === dailyId);
                        return option || { value: dailyId, label: dailyId };
                    });

                    setSelectedOptions(selectedOptions);
                    setSearchTerm(workoutProgram.workOutName);
                    setWeekDuration(workoutProgram.weekDuration);
                } catch (error) {
                    console.error('Error fetching workout program:', error);
                }
                setLoader(false);
            }
        };

        fetchWorkoutProgram();
    }, [id, options]);

    const handleSearchChange = inputValue => {
        setSearchTerm(inputValue);
    };

    const handleWeekDurationChange = event => {
        setWeekDuration(event.target.value);
    };

    const handleSubmit = async () => {
        setLoader(true);

        
        try {
            const dailyIds = selectedOptions.map(option => option.value);
            const requestBody = {
                workOutName: searchTerm,
                dailyIds: dailyIds,
                weekDuration: weekDuration,
                lock: true
            };

            const url = id
            ? `${process.env.REACT_APP_API_BASE_URL}/add/editWorkOutProgram/${id}`
            : `${process.env.REACT_APP_API_BASE_URL}/add/addWorkOutProgram`;
    
          const response = await axios({
            method: id ? 'put' : 'post',
            url: url,
            data: requestBody,
            headers: {
              Authorization: `Bearer ${token}`,
            },
          });
            if (response.status === 200) {
                toast.success(response.data.message);
                setLoader(false);
                setSelectedOptions([]);
                setSearchTerm("");
                setWeekDuration("");
            }

            console.log('API Response:', response.data);
        } catch (error) {
            console.error('Error adding workout program:', error);
            setLoader(false);
        }
    };

    const handleSelectChange = selectedOptions => {
        setSelectedOptions(selectedOptions);
    };

    return (
        <div>
            <Breadcrumbs mainTitle="Workout Program" parent="Admin" title="Manage Workout Program" />

            {!loader ? (
                <Card>
                    <HeaderCard title="Workout Program" />

                    <CardBody>
                        <FormGroup>
                            <Label htmlFor="searchWorkout">Enter Workout:</Label>
                            <Input
                                type="text"
                                id="searchWorkout"
                                placeholder="Enter workout name..."
                                value={searchTerm}
                                onChange={e => handleSearchChange(e.target.value)}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label htmlFor="selectWorkouts">Select Workouts:</Label>
                            <Select
                                id="selectWorkouts"
                                options={options}
                                isMulti
                                onChange={handleSelectChange}
                                value={selectedOptions}
                                placeholder="Select workouts..."
                                noOptionsMessage={() => 'No options found'}
                            />
                        </FormGroup>

                        <FormGroup>
                            <Label htmlFor="weekDuration">Week Duration:</Label>
                            <Input
                                type="number"
                                id="weekDuration"
                                placeholder="Enter week duration"
                                value={weekDuration}
                                onChange={handleWeekDurationChange}
                            />
                        </FormGroup>

                        <Button color="success" onClick={handleSubmit}>
                            {id ? 'Edit' : 'Submit'}
                        </Button>
                    </CardBody>
                </Card>
            ) : (
                <div>loading......</div>
            )}
        </div>
    );
};

export default WorkoutProgram;
